import React, { Children, type ReactNode } from 'react'
import Margin from '../Margin'

type Props = {
	space: number
	units?: string
	children: ReactNode
}

export default function StackComponent({ children, units, space }: Props): React.ReactNode {
	return (
		<div>
			{Children.map(children, child => (
				<Margin units={units} space={space}>
					{child}
				</Margin>
			))}
		</div>
	)
}
